<script setup lang="ts">
import { useDialogsStore } from '@/store/dialogs/dialogs'
import { DIALOGS } from '@/store/dialogs/dialogs.constants'

import HeaderCitySelectDialog from '@/components/Header/HeaderCitySelectDialog.vue'
import LoginDialog from '@/components/Login/LoginDialog.vue'
import DialogCheckAddress from '@/components/MenuByPoints/dialogs/DialogCheckAddress.vue'

const { closeDialog } = useDialogsStore()
const { dialogs } = storeToRefs(useDialogsStore())
</script>

<template>
  <dialog-check-address />

  <header-city-select-dialog />

  <login-dialog
    sign-in-redirect-path="/"
    :model-value="dialogs.login.visible"
    @update:model-value="closeDialog(DIALOGS.LOGIN)"
  />
</template>
